var MainComponent;

$(function() {
  MainComponent = Vue.component('main-vue', {
    template: '#main-vue',
    data: function() {
      return {
        message: 'Это Вью!'
      }
    }
  });
});